// extracted by mini-css-extract-plugin
export var marginNegative = "_61-5 _61-3 _61-1";
export var marginPositive = "_61-4 _61-3 _61-1";
export var modalContent = "_61-6";
export var samplesTable = "_61-8";
export var samplesTableContainer = "_61-7";
export var statBox = "_61-a";
export var tableCell = "_61-1";
export var tableCellCenter = "_61-2 _61-1";
export var tableCellRight = "_61-3 _61-1";
export var tableHeader = "_61-0";
export var trackingNumber = "_61-9";